/**
 * Search across candidates.
 */

import type { RouteManifestEntry } from '../route-manifest.js';

export const SEARCH_ROUTES: readonly RouteManifestEntry[] = [
  {
    id: 'search',
    path: '/search',
    entitlement: 'candidates',
    // Search is a read over the candidate database, so it is the same permission the list carries.
    requires: { action: 'read', resource: 'candidate' },
    authenticated: true,
    /*
     * **No `nav`, and that is the change** — CO2 §2.2, owed since it was written.
     *
     * Search is not a place; it is a way of getting to one. In the sidebar it sat between
     * Interviews and Team as though it were a sixth destination, and it took a click to reach a
     * box that then took a second click to use. It lives in the top bar now, beside the scope
     * selector — reachable from every screen, with `/` focusing it. The screen survives at this
     * path, because a set of results is something a person links to.
     */
    /*
     * The two things a search URL has to carry — 25 Aug 2026.
     *
     * **`q` was already being sent and silently dropped.** `TopSearch` navigates here with
     * `{ q: term }`, and the screen started from an empty form and never looked at the URL — so
     * typing in the header and pressing return opened an empty search box. The control worked, the
     * handoff did not, and nothing said so.
     *
     * `job` is section 8.3's context. Searching *for a job* is the ordinary case rather than a
     * special one, and putting it in the URL is what makes it linkable: a sourcer can be sent
     * "find me people for this" as an address rather than as an instruction.
     */
    validateSearch: (search) =>
      Object.fromEntries(
        (['q', 'job'] as const)
          .filter((key) => typeof search[key] === 'string' && search[key] !== '')
          .map((key) => [key, String(search[key])]),
      ),
    load: () => import('../screens/search.js'),
  },
];
